// A tab opened before a publication keeps the old code: when a new version is online the page reloads itself
// (only when nobody is typing or has a window open, so no work is lost).
const mainOf = (html) => (html.match(/static\/js\/(main\.[\w]+\.js)/) || [])[1];

export function watchVersion() {
  const mine = mainOf([...document.scripts].map((s) => s.src).join(" "));
  if (!mine) return;  // development build
  let stale = false;
  const busy = () => {
    const a = document.activeElement;
    return (a && /INPUT|TEXTAREA/.test(a.tagName) && a.value) || document.querySelector('[role="dialog"], [role="alertdialog"]');
  };
  const check = async () => {
    if (!stale) {
      try { const r = await fetch(`/?v=${Date.now()}`, { cache: "no-store" }); const m = mainOf(await r.text()); stale = !!m && m !== mine; } catch { /* offline: next time */ }
    }
    if (stale && !busy()) window.location.reload();
  };
  setInterval(check, 60000);
  document.addEventListener("visibilitychange", () => { if (!document.hidden) check(); });
  window.addEventListener("focus", check);
  check();
}
